import React, { useEffect, useState, useContext } from "react";
import { Dialog, DialogTitle } from "@mui/material";

import Swal from "sweetalert2";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";
import LinkAccSessToAppHourReq from "../../../../Classes/Models/Requests/Appointments/LinkAccSessToAppHourReq";
import SingleSessionsApps from "./SingleSessionsApps";
import { useLocation } from "react-router-dom";
import { UserContext } from "App";
import SearchUserReq from "../../../../Classes/Models/Requests/Users/SearchUser";
import UsersApi from "../../../../Classes/API/UsersApi";
const CreateAppointmentPopUp = ({
  GetAppDayById,
  AppDay,
  AppHour,
  ShowCreateAppointment,
  EnableModal,
  setAppDay,
  DayPartitionNumber,
  AddSession,
}) => {
  let state = useLocation();
  const User = useContext(UserContext);
  const [AccSession, SetAccSession] = useState({});
  const [CreateIsReady, setCreateIsReady] = useState(false);
  if (AppHour == null) {
    return null;
  }

  const CreateAppointment = async () => {
    EnableModal(false, {});
    Swal.fire({
      title: "Processing",
      text: "Please wait...",
      didOpen: () => {
        Swal.showLoading();
      },
      icon: "info",
      toast: true,
      position: "top-end",
      showConfirmButton: false,
    });
    if (AccSession.isAdmitted == true && User.userType != "Admin") {
      Swal.fire({
        title: "Not Allowed",
        text: "This session is already admitted. Contact admin to change.",
        icon: "error",
        didOpen: () => {
          Swal.hideLoading();
        },
        allowOutsideClick: true,
        showCancelButton: true,
      });
      return;
    }

    let req = new LinkAccSessToAppHourReq(AccSession.id, AppHour.id, false, false);
    let res = await AppointmentsApi.LinkAccountingSessionToAppointmentHour(req);
    if (res.status == "Success") {
      console.log(res.data);
      AddSession(res.data, AppHour);
      let sendMessage = await Swal.fire({
        title: "Success",
        text: `Appointment created successfully -- ${AccSession.patientName}, ${
          AccSession.sessionName
        }, with ${AccSession.therapistName} at ${new Date(
          AppHour.appointmentHourTime
        ).toLocaleString()}`,
        icon: "success",
        toast: true,
        position: "top-end",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Send Whatsapp",
        cancelButtonText: "Close",
        confirmButtonColor: "darkgreen",
        cancelButtonColor: "#ff0000",
      });
      if (sendMessage.isConfirmed) {
        SendWhatsapp({
          patientId: AccSession.patientId,
          AppHour: AppHour,
          AccSession: AccSession,
        });
      }
      //   Swal.fire({
      //     title: "Success",
      //     text: "Re-fething data...",
      //     didOpen: () => {
      //       Swal.showLoading();
      //     },
      //     icon: "success",
      //     toast: true,
      //     position: "top-end",
      //     showConfirmButton: false,
      //     timer: 5000,
      //   });
      //   SetAccSession({});
      //   let res2 = await GetAppDayById(AppDay.id, DayPartitionNumber);
      //   if (res2.status == "Success") {
      //     setAppDay(res2.data);
      //     let sendMessage = await Swal.fire({
      //       title: "Success",
      //       text: `Appointment created successfully -- ${AccSession.patientName}, ${
      //         AccSession.sessionName
      //       }, with ${AccSession.therapistName} at ${new Date(
      //         AppHour.appointmentHourTime
      //       ).toLocaleString()}`,
      //       icon: "success",
      //       toast: true,
      //       position: "top-end",
      //       showConfirmButton: true,
      //       showCancelButton: true,
      //       confirmButtonText: "Send Whatsapp",
      //       cancelButtonText: "Close",
      //       confirmButtonColor: "darkgreen",
      //       cancelButtonColor: "#ff0000",
      //     });
      //     if (sendMessage.isConfirmed) {
      //       SendWhatsapp({
      //         patientId: AccSession.patientId,
      //         AppHour: AppHour,
      //         AccSession: AccSession,
      //       });
      //     }
      //   } else {
      //     Swal.fire({
      //       title: "Failed",
      //       text: res.message,
      //       icon: "error",
      //     });
      //   }
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  const SendWhatsapp = async ({ patientId, AppHour, AccSession }) => {
    let req = new SearchUserReq();
    req.patientId = patientId;
    let res = await UsersApi.SearchUsers(req);
    if (res.status == "Success") {
      let patient = res.data.list[0];
      let phone = patient.number.replace(/[^\w\s]/gi, "").replace(/ /g, "");
      // let message = `Hi ${patient.name}, your appointment is at ${AppHour.appointmentHourTime} with ${AccSession.therapistName} for ${AccSession.sessionName}`;
      let message = `Hi ${
        patient.name
      }, this is an automated message from Elagi Center. Your appointment is at ${new Date(
        AppHour.appointmentHourTime
      ).toLocaleString()} with ${AccSession.therapistName} for ${
        AccSession.sessionName
      }. Please let us know at least 24 hours in advance if you want make any changes. Thank you.`;
      let url = `https://web.whatsapp.com/send?phone=${phone}&text=${message}`;
      window.open(url, "_blank");
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  useEffect(() => {
    let createReady = true;
    if (Object.keys(AccSession).length > 0 && Object.keys(AppHour).length > 0) {
      createReady = true;
    } else {
      createReady = false;
    }
    setCreateIsReady(createReady);
  }, [AccSession, AppHour]);

  return (
    <Dialog
      className="AppointmentPopUp"
      fullWidth
      id="appPopUp"
      maxWidth="6000px"
      open={ShowCreateAppointment}
      onClose={() => EnableModal(false, {})}
    >
      <MDBox
        className="AppPopUpTop"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
      >
        {AppHour && (
          <MDBox
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            pt={2}
            px={2}
            mb={3}
          >
            {Object.keys(AppHour).length > 0 ? (
              <MDTypography variant="h6">Selected Hour Id: {AppHour.id}</MDTypography>
            ) : (
              <MDTypography variant="h6">No Appointment Hour Selected</MDTypography>
            )}
          </MDBox>
        )}

        <MDBox display="flex" alignItems="center" pt={2} px={2}>
          <MDTypography mr={5} variant="h6">
            Accounting Session ID:
          </MDTypography>
          {Object.keys(AccSession).length > 0 ? (
            <MDTypography color="success" variant="h6">
              {AccSession.id}
            </MDTypography>
          ) : (
            <MDTypography color="warning" variant="h6">
              No Session Selected
            </MDTypography>
          )}
        </MDBox>

        <button
          onClick={() => CreateAppointment()}
          className="btn btn-dark m-2"
          disabled={!CreateIsReady}
        >
          Create Appointment
        </button>
      </MDBox>

      <div>
        <SingleSessionsApps SetAccSession={SetAccSession} />
      </div>
    </Dialog>
  );
};

export default CreateAppointmentPopUp;
